<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M8.99951 5.83301C8.99943 5.21444 8.7542 4.62107 8.31689 4.18359C7.87931 3.74601 7.28535 3.5 6.6665 3.5H2.6665V14H7.49951C8.02328 14 8.53514 14.1177 8.99951 14.3379V5.83301ZM10.9995 17.5C10.9995 18.0523 10.5518 18.5 9.99951 18.5C9.44738 18.4998 8.99951 18.0522 8.99951 17.5C8.99951 17.1022 8.84142 16.7208 8.56006 16.4395C8.27876 16.1583 7.89725 16 7.49951 16H1.6665C1.11422 16 0.666504 15.5523 0.666504 15V2.5C0.666504 1.94772 1.11422 1.5 1.6665 1.5H6.6665C7.81578 1.5 8.9183 1.95687 9.73096 2.76953C10.5433 3.58208 10.9994 4.68401 10.9995 5.83301V17.5Z" fill="#858E97"/>
        <path d="M9 17.5V5.83301C9.00009 4.68385 9.45699 3.5821 10.2695 2.76953C11.0821 1.95694 12.1839 1.50008 13.333 1.5H18.333C18.8853 1.5 19.333 1.94772 19.333 2.5V15C19.333 15.5523 18.8853 16 18.333 16H12.5C12.1023 16 11.7209 16.1582 11.4395 16.4395C11.1582 16.7209 11 17.1023 11 17.5C11 18.0523 10.5523 18.5 10 18.5C9.44772 18.5 9 18.0523 9 17.5ZM11 14.3379C11.4644 14.1176 11.9761 14 12.5 14H17.333V3.5H13.333C12.7143 3.50008 12.1211 3.7461 11.6836 4.18359C11.2461 4.62111 11.0001 5.2143 11 5.83301V14.3379Z" fill="#858E97"/>
    </svg>

</template>

<script>
export default {
    name: 'IconNews',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
